export default __webpack_public_path__ + "static/media/bootstrap.247c0644.png";